// A LOGO: uma bola de basquete quicando. So a bola.
//
// Nao e emoji. O 🏀 muda de desenho em cada sistema -- no Windows ele sai
// achatado e com contorno preto, e a marca do jogo nao pode depender de qual
// aparelho a pessoa usa. Aqui e SVG, entao e igual em todo lugar.
//
// O quique e CSS: a bola sobe e desce, e a sombra no chao encolhe quando ela
// esta no alto. Sem a sombra, o movimento parece a bola "flutuando"; e a
// sombra que faz o olho entender que existe um chao.

import React from 'react';

export function Ball({ size = 76, bouncing = true, className = '' }) {
  return (
    <span
      className={`ball-wrap ${bouncing ? 'bounce' : ''} ${className}`}
      style={{ '--ball': `${size}px` }}
      aria-hidden="true"
    >
      <span className="ball-shadow" />
      <span className="ball-body">
        <svg viewBox="0 0 100 100" width="100%" height="100%" role="img" aria-label="bola de basquete">
          {/* O couro. O brilho fora do centro e o que da volume a uma esfera. */}
          <defs>
            <radialGradient id="couro" cx="34%" cy="28%" r="78%">
              <stop offset="0%" stopColor="#fdba74" />
              <stop offset="45%" stopColor="#f97316" />
              <stop offset="100%" stopColor="#9a3412" />
            </radialGradient>
          </defs>
          <circle cx="50" cy="50" r="48" fill="url(#couro)" />

          {/* As costuras. Duas curvas laterais e a cruz -- e esse desenho, e
              nao a cor, que faz alguem reconhecer "basquete" de longe. */}
          <g fill="none" stroke="#7c2d12" strokeWidth="3.2" strokeLinecap="round" opacity=".9">
            <circle cx="50" cy="50" r="48" strokeWidth="3.6" />
            <path d="M50 2 V98" />
            <path d="M2 50 H98" />
            <path d="M14 14 C34 34 34 66 14 86" />
            <path d="M86 14 C66 34 66 66 86 86" />
          </g>
        </svg>
      </span>
    </span>
  );
}
